import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../../api';

const SchoolsAndColleges = () => {
    const { campus_slug } = useParams();
    const [schools, setSchools] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSchools = async () => {
            try {
                const response = await api.get(`/api/campus/${campus_slug}/schools`);
                setSchools(response.data);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchSchools();
    }, []);

    if (loading || error || schools.length === 0) {
        return <></>;
    }

    return (
        <section>
            <div className="container">
                <div className=" ac-overview  pb_80">    <div className="sec-title text-center">
                  <h2>Academic Programs</h2>
                </div>
                    
                    <div className="row justify-content-center">
                        {schools.map((school, index) => (
                            <div key={school.slug} className="col-lg-4 col-sm-6 col-md-4 mb-4 wow fadeIn" 
                                 data-wow-duration="2s" data-wow-delay={`${0.2 * (index % 3)}s`}>
                                <Link to={school.link}>
                                    <div className="card facility-card">
                                        <div className="overflow-hidden">
                                            <img src={process.env.REACT_APP_API_URL + '/public/' + school.img} 
                                                className="card-img-top facility-img" 
                                                alt={school.title} />
                                        </div>
                                        <div className="card-body align-items-center d-flex justify-content-center">
                                            <p className="college_title mb-0">{school.title}</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SchoolsAndColleges;